import { cn } from "../utils";
import type { HTMLAttributes, ReactNode } from "react";

export interface MainContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Maximum width variant */
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
}

const maxWidthClasses = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  "2xl": "max-w-screen-2xl",
  full: "max-w-full",
};

export function MainContainer({
  className,
  children,
  maxWidth = "xl",
  ...props
}: MainContainerProps) {
  return (
    <div
      className={cn("mx-auto px-4 sm:px-6 lg:px-10 xl:px-12", maxWidthClasses[maxWidth], className)}
      {...props}
    >
      {children}
    </div>
  );
}
